export async function collectPages<T>(
  fetchPage: (offset: number, limit: number) => Promise<T[]>,
  limit: number,
): Promise<T[]> {
  const result: T[] = [];
  let pageLength = limit;

  while (pageLength === limit) {
    const page = await fetchPage(result.length, limit);
    result.push(...page);
    pageLength = page.length;
  }

  return result;
}
